import React, {createContext, useRef, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Snackbar} from '@tkww/orion-web-ds-feedback';
import noop from '../utils/noop';

const Context = createContext({
  showSnackbar: noop,
  dismissSnackbar: noop,
});

export default Context;

export const SnackbarContextProvider = ({children}) => {
  const snackbarElement = useRef(null);

  const values = useMemo(() => {
    const showSnackbar = toastMessage => {
      snackbarElement.current.showAndDismiss({
        data: toastMessage,
        dismissTimeout: 2000,
      });
    };

    const dismissSnackbar = () => {
      snackbarElement.current.dismiss();
    };

    return {
      showSnackbar,
      dismissSnackbar,
    };
  }, []);

  return (
    <Context.Provider value={values}>
      <>
        {children}
        <Snackbar ref={snackbarElement}>
          {data => {
            return data;
          }}
        </Snackbar>
      </>
    </Context.Provider>
  );
};

SnackbarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
